module.exports = __webpack_public_path__ + "static/engagement-dd2651c50732a1c6c93b43d3d5e7f250.png";